import React from 'react'
import { Row, Col, Card, Button } from 'antd'
import { useNavigate } from 'react-router-dom'
import {
  UserOutlined,
  MedicineBoxOutlined,
  FileSearchOutlined,
  ArrowRightOutlined,
} from '@ant-design/icons'
import './ToolsHome.css'

const ToolsHome: React.FC = () => {
  const navigate = useNavigate()

  const tools = [
    {
      key: 'constitution',
      icon: <UserOutlined className="tool-icon" />,
      title: '体质识别',
      description: '基于中医体质理论，识别您的体质类型',
      color: '#2E7D32',
      path: '/tools/constitution',
    },
    {
      key: 'medicine',
      icon: <MedicineBoxOutlined className="tool-icon" />,
      title: '方药识别',
      description: '识别中药饮片和方剂，提供详细信息',
      color: '#C62828',
      path: '/tools/medicine',
    },
    {
      key: 'diagnosis',
      icon: <FileSearchOutlined className="tool-icon" />,
      title: '智能诊断',
      description: 'AI辅助医学影像诊断分析',
      color: '#0277BD',
      path: '/tools/diagnosis',
    },
  ]

  return (
    <div className="tools-home-page">
      <div className="page-header">
        <h1 className="page-title">智能工具</h1>
        <p className="page-subtitle">便捷的中医药智能工具集合</p>
      </div>

      <div className="tools-grid">
        <Row gutter={[24, 24]}>
          {tools.map((tool) => (
            <Col xs={24} sm={12} lg={8} key={tool.key}>
              <Card
                className="tool-card card-hover"
                onClick={() => navigate(tool.path)}
                hoverable
              >
                <div className="tool-icon-wrapper" style={{ color: tool.color }}>
                  {tool.icon}
                </div>
                <h3 className="tool-title">{tool.title}</h3>
                <p className="tool-description">{tool.description}</p>
                <Button
                  type="link"
                  icon={<ArrowRightOutlined />}
                  className="tool-link"
                  style={{ color: tool.color }}
                >
                  开始使用
                </Button>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  )
}

export default ToolsHome

